import React, { useState } from "react";
import CommonInput from "../../../CommonMethhods/CommonInput";
import CommonSelect from "../../../CommonMethhods/CommonSelect";

function NonIndividualDetailsAccordian() {
  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },
  ];

  return (
    <div
      className="tab-content refer-tab-content individual-acc-accordian"
      id="knowledgeTabContent"
    >
      <div
        className="tab-pane fade show active"
        id="module-tab-pane"
        role="tabpanel"
        aria-labelledby="module-tab"
        tabIndex={0}
      >
        <div className="accordion" id="accordionKnowledge">
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Basic Details
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
                <div className="row border-parent accordian-section-wrapper">
                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Full Name"
                      name="fullName"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Date of Birth"
                      name="search-text"
                      placeholder="DD/MM/YYYY"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="PAN Number"
                      name="search-text"
                      placeholder="Enter PAN card number"
                      required
                    />
                  </div>

                  <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Personal Details
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
                <div className="row border-parent accordian-section-wrapper">
                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Father’s Name"
                      name="search-text"
                      placeholder="Enter your father’s name"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Gender"
                      name="gender"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Marital Status"
                      name="maritalStatus"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Income Range"
                      name="income"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Occupation"
                      name="occupation"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Business Type"
                      name="businessType"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Opt for DDPI"
                      name="ddpi"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Activate F&O"
                      name="fno"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Nationality"
                      name="search-text"
                      placeholder="Enter nationality"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Residential Status"
                      name="search-text"
                      placeholder="Enter residential status"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Type of Account"
                      name="fno"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Trading Preferences"
                      name="fno"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Present Address Line 1"
                      name="search-text"
                      placeholder="Enter address details"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Present Address Line 2"
                      name="search-text"
                      placeholder="Enter address details"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Pincode"
                      name="search-text"
                      placeholder="Enter pincode"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="City"
                      name="city"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="State"
                      name="state"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Permanent Address"
                      name="pAddress"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Permanent Address Line 1"
                      name="search-text"
                      placeholder="Enter address details"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Permanent Address Line 2"
                      name="search-text"
                      placeholder="Enter address details"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Pincode"
                      name="search-text"
                      placeholder="Enter pincode"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="City"
                      name="city"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="State"
                      name="state"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Add Nominee Details"
                      name="nominee"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Net Worth (Older than 1 year as on date)"
                      name="search-text"
                      placeholder="Enter net worth in rupees"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Trading Experience"
                      name="tradeExp"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Are you Politically Exposed Person?"
                      name="politicExposed"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                    <CommonSelect
                      label="Past Actions"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="true"
                aria-controls="collapseThree"
              >
                Nominee Details
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
                <div className="row border-parent accordian-section-wrapper">
                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Full Name"
                      name="fullName"
                      placeholder="Enter your full name"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Nominee Date of Birth*"
                      name="search-text"
                      placeholder="DD/MM/YYYY"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian individiual-select">
                  <CommonSelect
                      label="Relationship to Nominee"
                      name="nominee-relation"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Percentage"
                      name="search-text"
                      placeholder="Enter percentage"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-4 card-accordian">
                    <CommonInput
                      label="Enter Aadhaar Card Number (Last 4 digits)"
                      name="search-text"
                      placeholder="Enter Aadhar Card Number"
                      required
                    />
                  </div>
                </div>
                <div className="nominee-btn-wrapper">
                  <div className="default-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Add Another Nominee
                    </button>
                  </div>
                  <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFour">
              <button
                className="accordion-button collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="true"
                aria-controls="collapseFour"
              >
                Bank Details
              </button>
            </h2>
            <div
              id="collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="headingFour"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body">
              <div className="row border-parent accordian-section-wrapper">
                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Bank Account Number"
                      name="fullName"
                      placeholder="Enter bank account number"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="Confirm Bank Account Number"
                      name="search-text"
                      placeholder="Re-enter bank account number"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                  <CommonInput
                      label="IFSC Code"
                      name="search-text"
                      placeholder="Enter IFSC code"
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Account Type"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="GST Registered"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>

                  <div className="col-sm-6 col-lg-3 card-accordian">
                    <CommonInput
                      label="GST Number"
                      name="search-text"
                      placeholder="Enter GST Number"
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="GST Document Collected"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                    <p>Please collect GST document for verification</p>
                  </div>
                </div>
                <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingFive">
              <button
                className="accordion-button collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="true"
                aria-controls="collapseFive"
              >
                Brokerage Details
              </button>
            </h2>
            <div
              id="collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="headingFive"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body ">
              <div className="row border-parent accordian-section-wrapper">
                <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Delivery (per trades)"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Intraday (per trades)"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Futures (per contract)"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>
                  <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Options (per contract)"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>
                </div>
                <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="headingSix">
              <button
                className="accordion-button collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="true"
                aria-controls="collapseSix"
              >
                Segment Activation
              </button>
            </h2>
            <div
              id="collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="headingSix"
              data-parent="#accordionKnowledge"
            >
              <div className="accordion-body ">
              <div className="row border-parent accordian-section-wrapper">
                <div className="col-sm-6 col-lg-3 card-accordian individiual-select">
                  <CommonSelect
                      label="Select Document"
                      name="actions"
                      options={genderOptions}
                      required
                    />
                  </div>
                </div>
                <div className="val-btn-wrap">
                    <button type="submit" className="validate-btn">
                      Save
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="tab-pane fade"
        id="video-tab-pane"
        role="tabpanel"
        aria-labelledby="video-tab"
        tabIndex={0}
      ></div>
    </div>
  );
}

export default NonIndividualDetailsAccordian;
